import { render, staticRenderFns } from "./SelectProductGroup.vue?vue&type=template&id=7c39089b&lang=pug"
import script from "./SelectProductGroup.vue?vue&type=script&lang=js"
export * from "./SelectProductGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports